import { Injectable } from '@angular/core';
import * as Forge from 'node-forge';
import { environment } from '../../environments/environment';
@Injectable({
  providedIn: 'root',
})
export class RSAHelper {
  publicKey: string 
  privateKey: string 
  constructor() {
    
  }

  

  encryptWithPublicKey(valueToEncrypt: string): string {

    this.publicKey = `-----BEGIN PUBLIC KEY-----
MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQD/sVFfUIVuvxZo1PcUCU8z9HdE
Wf1Err+rJOGbJdzb/0af0vCdGh5tsAvJ+8R0hNZ718Ago4zXLCGReMYeoZeGUUi4
4I4zV272IlX5LZRhJFfWgiP3yrsOtsYM8aq3+aFNXz+5gCG/RUwjkCptoJYu7mME
vowcNZNbRRssBMvZDQIDAQAB
-----END PUBLIC KEY-----`;

    const rsa = Forge.pki.publicKeyFromPem(this.publicKey);
    return window.btoa(rsa.encrypt(valueToEncrypt.toString()));
  }



  decryptWithPrivateKey(valueTodecrypt: string): string {
    this.privateKey = `-----BEGIN RSA PRIVATE KEY-----
MIICWwIBAAKBgQD/sVFfUIVuvxZo1PcUCU8z9HdEWf1Err+rJOGbJdzb/0af0vCd
Gh5tsAvJ+8R0hNZ718Ago4zXLCGReMYeoZeGUUi44I4zV272IlX5LZRhJFfWgiP3
yrsOtsYM8aq3+aFNXz+5gCG/RUwjkCptoJYu7mMEvowcNZNbRRssBMvZDQIDAQAB
AoGAF5ykSw0AhW2YAC5Kcss5SS72JJW60bDhekh5nP4uGxLDztaH6boTvUVYkVpy
ld/+fok58Mmpo+UrZGemxAVgHJP8S8zZMB5m9H2eFQvfAC0YAy2HqdWm3go0x7BB
04eprE5no04eoGBfD6MBVAz4HXszOfQQvpoqLxNHUpSm3PECQQD/5iCFO2bgVkl/
gEgo4r278KThp0dYsgqnVlFOuqNN+xdSi92V73VetE3Wm4p+ilgaNc3OVx5LKBoc
8eFQ9VQjAkEA/8srgzaAV6oQcKSCvnlK6X6zgeksaeJIM91Laa8d6d0z2MKtJCaC
Hh1VYjXCNgE+vyp1ZzW5mtyQ9SFuEQGZDwJAVxzaGUDdhqUZJCRhbDmz6VTEbGTr
rs/9PHXv++MhUJyXlewzJKV9yR2MGfCdNvKVh2alhwa1M1SVfyEAWPULDQJAeDmz
CuoL6qg5L+hytznlNtfhYTcKM/4yN4ZUkqjHI4tfegsOPAaJc8QPxKhFzwJIzqsT
IV6EDUCMNVrwE7gviwJAZqYRkNBVkxD7mcysRjss749jzVdQiDACyqOEHhEVSP30
uSoNLzRrOp4IyNN86dcrllNbn2jifgWG17x+QWDoww==
-----END RSA PRIVATE KEY-----`;

    const privateKey = Forge.pki.privateKeyFromPem(this.privateKey);
    const decodeText = Forge.util.decode64(valueTodecrypt);
    const decrypted = privateKey.decrypt(decodeText);
  
    return decrypted;
;
  }
 
}
